import UserAvatar from 'components/UserAvatar/UserAvatar'
import UserMenu from '../UserMenu/UserMenu'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import { useState } from 'react'
import getTestId from 'utils/getTestId'

import style from './User.module.css'

const User: React.FC<{
  email?: string
  firstName?: string
  lastName?: string
  avatarUrl?: string | null
}> = ({ email, firstName, lastName, avatarUrl }) => {
  const [open, setOpen] = useState(false)

  const onClick = (): void => {
    setOpen(prev => !prev)
  }

  const onClickAway = (): void => {
    setOpen(false)
  }

  return (
    <div className={style.userMenuBlock} onClick={onClick} data-test-id={getTestId('user-avatar')}>
      <div className={style.avatar}>
        <UserAvatar url={avatarUrl} firstName={firstName} lastName={lastName} email={email} size={36} />
      </div>
      {open ? (
        <ClickAwayListener onClickAway={onClickAway}>
          <div onClick={e => e.stopPropagation()}>
            <UserMenu onRequestClose={() => setOpen(false)} />
          </div>
        </ClickAwayListener>
      ) : null}
    </div>
  )
}

export default User
